// extracted by mini-css-extract-plugin
export default {"video":"Video_video__TtHWF","title":"Video_title__RU3PB"};